module.exports = __webpack_public_path__ + "media/images/icons/email-with-bg-01867e64214768335efe23dcd1e94599.svg";